import React, { useEffect, useState } from "react";
import { Button } from "../../../design/button";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "../../../design/dialog";
import { ErrorMessage, Field, Fieldset, Label } from "../../../design/fieldset";
import { useDiscoveryRequestTask } from "../../../contexts/DiscoveryRequestTaskContext";
import { useParticipant } from "../../../contexts/ParticipantContext";
import { DiscoveryRequestTask } from "../../../models/DiscoveryRequestTask";
import { Textarea } from "../../../design/textarea";

interface Props {
  discoveryRequestTask: DiscoveryRequestTask;
}

interface Errors {
  startDate?: string;
  endDate?: string;
  matterId?: string;
  participantId?: string;
}

const EditDiscoveryRequestTaskButton: React.FC<Props> = ({
  discoveryRequestTask,
}) => {
  const { participants } = useParticipant();
  const { updateDiscoveryRequestTask } = useDiscoveryRequestTask();
  const [isOpen, setIsOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // const [date, setDate] = useState<string>(
  //   toLocalDateString(discoveryRequestTask.discoveryRequestTaskDate).slice(0, 10),
  // );
  // const [time, setTime] = useState<string>(
  //   toLocalTimeString(discoveryRequestTask.discoveryRequestTaskDate).slice(11, 16),
  // );
  const [description, setDescription] = useState<string>(
    discoveryRequestTask.description ?? "",
  );
  const [errors, setErrors] = useState<Errors>({});

  useEffect(() => {}, [discoveryRequestTask]);

  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};
    // if (!date.trim()) {
    //   newErrors.startDate = "Start date is required.";
    // }
    // if (!time.trim()) {
    //   newErrors.endDate = "End date is required.";
    // }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }
    setIsSaving(true);
    setError(null);

    try {
      const data = {
        // discoveryRequestTaskType: discoveryRequestTaskTypeId,
        // discoveryRequestTaskSubtype: discoveryRequestTaskSubtypeId,
        // matter: discoveryRequestTask.matter,
        // discoveryRequestTaskDate: new Date(`${date}T${time}`),
        // participants: Array.from(new Set(participantIds)),
        // description,
        // significance,
      } as DiscoveryRequestTask;

      await updateDiscoveryRequestTask(discoveryRequestTask._id, data);
      clearForm();
    } catch (e) {
      console.error(e);
      setError("Failed to update discoveryRequestTask. Please try again.");
    } finally {
      setIsSaving(false);
    }
  };

  const clearForm = () => {
    setIsOpen(false);
    setError(null);
  };

  return (
    <>
      <Button type="button" onClick={() => setIsOpen(true)}>
        Edit
      </Button>
      <Dialog open={isOpen} onClose={setIsOpen}>
        <DialogTitle>Edit Task</DialogTitle>
        <DialogBody>
          {error && <ErrorMessage>{error}</ErrorMessage>}
          <Fieldset>
            <Field>
              <Label htmlFor="description">Description</Label>
              <Textarea
                id="description"
                value={description}
                placeholder="What happened?"
                onChange={(e) => setDescription(e.target.value)}
                disabled={isSaving}
              />
            </Field>
          </Fieldset>
        </DialogBody>
        <DialogActions>
          <Button plain onClick={clearForm}>
            Cancel
          </Button>
          <Button disabled={isSaving} onClick={handleSubmit}>
            {isSaving ? "Saving..." : "Save"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EditDiscoveryRequestTaskButton;
